import { BaseEntity } from '../../../models';

export class CondicaoPagamentoPrazo implements BaseEntity {
    readonly id: number;
    idCondicaoPagamento: number;
    prazo: number;
}
